import { render, staticRenderFns } from "./ReadonlyBanner.vue?vue&type=template&id=5388105b&"
import script from "./ReadonlyBanner.vue?vue&type=script&lang=js&"
export * from "./ReadonlyBanner.vue?vue&type=script&lang=js&"
import style0 from "./ReadonlyBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports